import appbar from './appbar/appbar';
import home from './home/home';
import people from './people/people';
export default {
    appbar,
    home,
    people
}
